// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-cards-section {
  padding: 4rem 0;
  background: var(--bg-primary);
  position: relative;
}

.project-cards-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);
}

.project-cards-header {
  text-align: center;
  margin-bottom: 3rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2rem;
}

.project-cards-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--text-primary), var(--accent-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.project-cards-subtitle {
  font-size: 1.1rem;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

.project-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.project-card {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.project-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #4F46E5;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.project-card:nth-child(1)::before {
  background: #4F46E5;
}

.project-card:nth-child(2)::before {
  background: #00C851;
}

.project-card:nth-child(3)::before {
  background: #FF6B35;
}

.project-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #4F46E5;
}

.project-card:nth-child(1):hover {
  border-color: #4F46E5;
}

.project-card:nth-child(2):hover {
  border-color: #00C851;
}

.project-card:nth-child(3):hover {
  border-color: #FF6B35;
}

.project-card:hover::before {
  transform: scaleX(1);
}

.project-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.project-image {
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #4F46E5, rgba(79, 70, 229, 0.1));
  border-radius: 12px;
  flex-shrink: 0;
}

.project-card:nth-child(1) .project-image {
  background: linear-gradient(135deg, #4F46E5, rgba(79, 70, 229, 0.1));
}

.project-card:nth-child(2) .project-image {
  background: linear-gradient(135deg, #00C851, rgba(0, 200, 81, 0.1));
}

.project-card:nth-child(3) .project-image {
  background: linear-gradient(135deg, #FF6B35, rgba(255, 107, 53, 0.1));
}

.project-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

.project-description {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.project-technologies {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.tech-tag {
  background: #4F46E5;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s ease;
}

.project-card:nth-child(1) .tech-tag {
  background: #4F46E5;
}

.project-card:nth-child(2) .tech-tag {
  background: #00C851;
}

.project-card:nth-child(3) .tech-tag {
  background: #FF6B35;
}

.tech-tag:hover {
  opacity: 1;
}

.project-card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.project-color-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4F46E5;
}

.project-card:nth-child(1) .project-color-indicator {
  background: #4F46E5;
}

.project-card:nth-child(2) .project-color-indicator {
  background: #00C851;
}

.project-card:nth-child(3) .project-color-indicator {
  background: #FF6B35;
}

.project-cards-actions {
  text-align: center;
  margin-top: 3rem;
  padding: 0 2rem;
}

.more-projects-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, var(--accent-coffee), var(--accent-beige));
  color: var(--accent-cream);
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);
}

.more-projects-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
  background: linear-gradient(135deg, var(--accent-beige), var(--accent-coffee));
}

.more-projects-btn:active {
  transform: translateY(0);
}

.arrow-icon {
  transition: transform 0.3s ease;
}

.more-projects-btn:hover .arrow-icon {
  transform: translateX(4px);
}

/* Dark theme support */
[data-theme="dark"] .project-cards-section {
  background: var(--bg-primary);
}

[data-theme="dark"] .project-card {
  background: var(--card-bg);
  border-color: var(--border-color);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

[data-theme="dark"] .project-card:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .project-cards-section {
    padding: 3rem 0;
  }
  
  .project-cards-header {
    margin-bottom: 2rem;
    padding: 0 1rem;
  }
  
  .project-cards-title {
    font-size: 2rem;
  }
  
  .project-cards-subtitle {
    font-size: 1rem;
  }
  
  .project-cards-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  
  .project-card {
    padding: 1.5rem;
  }
  
  .project-card-header {
    margin-bottom: 1rem;
  }
  
  .project-image {
    width: 50px;
    height: 50px;
    font-size: 2rem;
  }
  
  .project-title {
    font-size: 1.3rem;
  }
  
  .more-projects-btn {
    padding: 0.875rem 1.5rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .project-cards-section {
    padding: 2rem 0;
  }
  
  .project-cards-title {
    font-size: 1.75rem;
  }
  
  .project-card {
    padding: 1.25rem;
  }
  
  .project-image {
    width: 45px;
    height: 45px;
    font-size: 1.75rem;
  }
  
  .project-title {
    font-size: 1.2rem;
  }
  
  .tech-tag {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectCards/ProjectCards.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,6EAA6E;EAC7E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oEAAoE;EACpE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,8EAA8E;EAC9E,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,8EAA8E;AAChF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":[".project-cards-section {\n  padding: 4rem 0;\n  background: var(--bg-primary);\n  position: relative;\n}\n\n.project-cards-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);\n}\n\n.project-cards-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 2rem;\n}\n\n.project-cards-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, var(--text-primary), var(--accent-color));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.project-cards-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.project-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.project-card {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.project-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: #4F46E5;\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.project-card:nth-child(1)::before {\n  background: #4F46E5;\n}\n\n.project-card:nth-child(2)::before {\n  background: #00C851;\n}\n\n.project-card:nth-child(3)::before {\n  background: #FF6B35;\n}\n\n.project-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  border-color: #4F46E5;\n}\n\n.project-card:nth-child(1):hover {\n  border-color: #4F46E5;\n}\n\n.project-card:nth-child(2):hover {\n  border-color: #00C851;\n}\n\n.project-card:nth-child(3):hover {\n  border-color: #FF6B35;\n}\n\n.project-card:hover::before {\n  transform: scaleX(1);\n}\n\n.project-card-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  gap: 1rem;\n}\n\n.project-image {\n  font-size: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #4F46E5, rgba(79, 70, 229, 0.1));\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.project-card:nth-child(1) .project-image {\n  background: linear-gradient(135deg, #4F46E5, rgba(79, 70, 229, 0.1));\n}\n\n.project-card:nth-child(2) .project-image {\n  background: linear-gradient(135deg, #00C851, rgba(0, 200, 81, 0.1));\n}\n\n.project-card:nth-child(3) .project-image {\n  background: linear-gradient(135deg, #FF6B35, rgba(255, 107, 53, 0.1));\n}\n\n.project-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.project-description {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.project-technologies {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.tech-tag {\n  background: #4F46E5;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  opacity: 0.9;\n  transition: opacity 0.2s ease;\n}\n\n.project-card:nth-child(1) .tech-tag {\n  background: #4F46E5;\n}\n\n.project-card:nth-child(2) .tech-tag {\n  background: #00C851;\n}\n\n.project-card:nth-child(3) .tech-tag {\n  background: #FF6B35;\n}\n\n.tech-tag:hover {\n  opacity: 1;\n}\n\n.project-card-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.project-color-indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #4F46E5;\n}\n\n.project-card:nth-child(1) .project-color-indicator {\n  background: #4F46E5;\n}\n\n.project-card:nth-child(2) .project-color-indicator {\n  background: #00C851;\n}\n\n.project-card:nth-child(3) .project-color-indicator {\n  background: #FF6B35;\n}\n\n.project-cards-actions {\n  text-align: center;\n  margin-top: 3rem;\n  padding: 0 2rem;\n}\n\n.more-projects-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, var(--accent-coffee), var(--accent-beige));\n  color: var(--accent-cream);\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);\n}\n\n.more-projects-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);\n  background: linear-gradient(135deg, var(--accent-beige), var(--accent-coffee));\n}\n\n.more-projects-btn:active {\n  transform: translateY(0);\n}\n\n.arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.more-projects-btn:hover .arrow-icon {\n  transform: translateX(4px);\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .project-cards-section {\n  background: var(--bg-primary);\n}\n\n[data-theme=\"dark\"] .project-card {\n  background: var(--card-bg);\n  border-color: var(--border-color);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"dark\"] .project-card:hover {\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .project-cards-section {\n    padding: 3rem 0;\n  }\n  \n  .project-cards-header {\n    margin-bottom: 2rem;\n    padding: 0 1rem;\n  }\n  \n  .project-cards-title {\n    font-size: 2rem;\n  }\n  \n  .project-cards-subtitle {\n    font-size: 1rem;\n  }\n  \n  .project-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding: 0 1rem;\n  }\n  \n  .project-card {\n    padding: 1.5rem;\n  }\n  \n  .project-card-header {\n    margin-bottom: 1rem;\n  }\n  \n  .project-image {\n    width: 50px;\n    height: 50px;\n    font-size: 2rem;\n  }\n  \n  .project-title {\n    font-size: 1.3rem;\n  }\n  \n  .more-projects-btn {\n    padding: 0.875rem 1.5rem;\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .project-cards-section {\n    padding: 2rem 0;\n  }\n  \n  .project-cards-title {\n    font-size: 1.75rem;\n  }\n  \n  .project-card {\n    padding: 1.25rem;\n  }\n  \n  .project-image {\n    width: 45px;\n    height: 45px;\n    font-size: 1.75rem;\n  }\n  \n  .project-title {\n    font-size: 1.2rem;\n  }\n  \n  .tech-tag {\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
